// extracted by mini-css-extract-plugin
export default {"tabs_wrapper":"tabs_tabs_wrapper__12l2a","item":"tabs_item__DgQdD","item_active":"tabs_item_active__zrUiz","line":"tabs_line__MbWLW"};